<template>
  <div class="flow-page">
    <!-- 出库单 -->
    <div class="table-container">
      <div class="page-header">
        <div class="header-bar"></div>
        <div class="header-content">
          <h2 class="header-title">出库单</h2>
          <div class="header-sub">OUTBOUND ORDER</div>
        </div>
      </div>
      <div class="card-body">
        

        <!-- 出库单内容 -->
        <OutEntrepot :outEntrepotId="id" />
      </div>
    </div>

    <!-- 出货单 -->
    <div class="table-container flow-container" v-if="!!shipmentId">
      <div class="page-header flow-header">
          <div class="header-bar"></div>
          <div class="header-content">
              <h2 class="header-title">发货信息</h2>
              <div class="header-sub">SHIPPING INFO</div>
          </div>
      </div>
      <div class="shipment-wrap">
        <Shipment :shipmentId="shipmentId" />
      </div>
    </div>

    <!-- 审核记录 -->
    <div class="table-container">
      <div class="page-header flow-header">
        <div class="header-bar"></div>
        <div class="header-content">
          <h2 class="header-title">审核记录</h2>
          <div class="header-sub">AUDIT RECORDS</div>
        </div>
      </div>
      <div class="flow-table-wrap">
        <el-table :data="tableData" border>
          <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
          <el-table-column prop="activityName" label="名称" align="center"></el-table-column>
          <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
          <el-table-column prop="assignee" label="负责人" align="center"></el-table-column>
          <el-table-column prop="status" label="处理结果" align="center"></el-table-column>
          <el-table-column prop="reason" label="处理意见" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
  import { historicActivityInstance} from "@/api/api.js";
  import Shipment from "./info/Shipment.vue";
  import OutEntrepot from "./info/OutEntrepot.vue";
  export default {
    components: {Shipment, OutEntrepot},
    data() {
      return{
        id: this.$route.query.id,
        processId: this.$route.query.processId,
        shipmentId: this.$route.query.shipmentId,
        formData:{},
        tableData:[],
      }
    },
    methods: {
      initHistoricActivity(){
        if (this.processId) {
          historicActivityInstance({processInstanceId: this.processId}).then(res=>{
            this.tableData = res.data.data;
          });
        }
      },
      replaceNewlines(text) {
        if (text) {
          return text.replace(/\n/g, "<br>");
        }
        return "";
      },
    },
    created() {
      this.titleCompany = this.titleCompanyList[0].value;
    },
    mounted() {
      this.initHistoricActivity()
    },
  };
</script>
<style scoped lang="less">
  @primary: #409EFF;
  @primary-dark: #337ECC;
  @text-primary: #303133;
  @text-regular: #606266;
  @bg-page: #F0F2F5;
  @bg-header: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);
  @border-color: #DCDFE6;
  @bg-section: #F5F7FA;

  .flow-page {
    min-height: 100vh;
    background: @bg-page;
    padding: 24px 16px 40px;
    box-sizing: border-box;
  }

  /* ================= 容器 ================= */
  .table-container {
    max-width: 1200px;
    margin: 0 auto 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    &.flow-container {
        margin-top: 16px;
        .shipment-wrap {
            padding: 16px;
        }
    }
  }

  /* ================= 标题区域 ================= */
  .page-header {
    display: flex;
    align-items: center;
    padding: 20px 28px;
    background: @bg-header;
    color: #fff;
    &.flow-header {
      padding: 16px 28px;
      .header-title {
        font-size: 18px;
      }
    }
  }
  .header-bar {
    width: 5px;
    height: 36px;
    background: #fff;
    border-radius: 3px;
    margin-right: 14px;
    opacity: 0.85;
  }
  .header-content {
    flex: 1;
  }
  .header-title {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 2px;
    line-height: 1.2;
  }
  .header-sub {
    margin-top: 4px;
    font-size: 12px;
    letter-spacing: 1.5px;
    opacity: 0.7;
  }

  /* ================= 卡片内容区 ================= */
  .card-body {
    padding: 20px 24px;
  }

  .filter-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
  }

  /* ================= 流程表格 ================= */
  .flow-table-wrap {
    padding: 16px;
  }

</style>
